export const ROLE_META = {
  superadmin: { label: "Super Admin", cls: "bg-gradient-to-r from-fuchsia-600 to-indigo-600 text-white border-fuchsia-600" },
  admin: { label: "Administrator", cls: "bg-zinc-900 text-white border-zinc-900" },
  manager: { label: "Manager", cls: "bg-brand text-white border-brand" },
  hire_manager: { label: "Services Manager", cls: "bg-teal-600 text-white border-teal-600" },
  hire_coordinator: { label: "Services Coordinator", cls: "bg-cyan-600 text-white border-cyan-600" },
  service_technician: { label: "Service Technician", cls: "bg-emerald-600 text-white border-emerald-600" },
  job_dispatcher: { label: "Job Dispatcher", cls: "bg-indigo-600 text-white border-indigo-600" },
  rigger: { label: "Rigger", cls: "bg-amber-500 text-zinc-950 border-amber-500" },
  viewer: { label: "Viewer", cls: "bg-slate-200 text-slate-700 border-slate-400" },
};

export const PRIORITY_META = {
  low: { label: "Low", cls: "bg-zinc-100 text-zinc-600 border-zinc-300" },
  medium: { label: "Medium", cls: "bg-orange-100 text-orange-700 border-orange-300" },
  high: { label: "High", cls: "bg-red-100 text-red-700 border-red-300" },
};

export const PRIORITY_ORDER = ["low", "medium", "high"];

// Colour palette for job statuses (badge classes). Keys are stored in the DB.
export const STATUS_COLORS = {
  yellow: "bg-yellow-100 text-yellow-800 border-yellow-300",
  blue: "bg-blue-100 text-blue-800 border-blue-300",
  cyan: "bg-cyan-100 text-cyan-800 border-cyan-300",
  purple: "bg-purple-100 text-purple-800 border-purple-300",
  emerald: "bg-emerald-100 text-emerald-800 border-emerald-300",
  orange: "bg-orange-100 text-orange-700 border-orange-300",
  red: "bg-red-100 text-red-700 border-red-300",
  pink: "bg-pink-100 text-pink-800 border-pink-300",
  indigo: "bg-indigo-100 text-indigo-800 border-indigo-300",
  zinc: "bg-zinc-200 text-zinc-700 border-zinc-400",
};

export const STATUS_COLOR_OPTIONS = Object.keys(STATUS_COLORS);

// Deterministic per-tenant accent colour (stable from the tenant id/name) for recognition dots.
export const TENANT_COLORS = [
  "#01ADEF", "#FE5000", "#22C55E", "#A855F7", "#EAB308", "#EC4899",
  "#14B8A6", "#F97316", "#3B82F6", "#EF4444", "#8B5CF6", "#10B981",
];

export function tenantColor(key) {
  if (!key) return "#94A3B8";
  const s = String(key);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return TENANT_COLORS[h % TENANT_COLORS.length];
}

